class Constants {
    static APIURL = process.env.REACT_APP_RETURNS_GHOSTBUSTER_API_URL;
}

export { Constants };
